import styled from 'styled-components';

export const CardBalanceText = styled.p`
  text-align: center;
`;

export const CurrentBalanceText = styled.p`
  text-align: center;
  font-size: 1.15rem;
  font-weight: bold;
`;

export const ModalHr = styled.hr`
  width: 100%;
  background-color: ${Styles.color.grey.six};
  margin: 32px 0;
`;

export const CurrentBalanceDescription = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
`;
